import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Layout from '../components/layout'

class WorkTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const siteDescription = post.excerpt

    return (
      <Layout location={this.props.location}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[{ name: 'description', content: siteDescription }]}
          title={`${post.frontmatter.title} | ${siteTitle}`}
        />{' '}
        <main>
          <div className="work">
            <div className="work__info">
              <h3 className="work__title">{post.frontmatter.title}</h3>
              <p className="work__date">{post.frontmatter.date}</p>
            </div>
            <div
              className="work__text"
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
          </div>
        </main>
      </Layout>
    )
  }
}

export default WorkTemplate

export const pageQuery = graphql`
  query WorksBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt
      html
      frontmatter {
        title
        date(formatString: "MMMM, YYYY")
        tags
        image {
          childImageSharp {
            resize(width: 1500, height: 1500) {
              src
            }
            fluid(maxWidth: 1200, maxHeight: 900) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`
